<template>
  <div class="myToDo">
    <div class="title" >
      <i class="el-icon-s-claim" style="color: #006eff"></i>
      我的待办
    </div>
    <ul>
      <li v-for="(item,index) in 4" :key="index" @click="routerTo(index)">
        <div class="itemName">{{ titleList[index] }}</div>
        <div class="num">
          <b>{{ numList[index] }}</b>
          <span>个</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      titleList: [ '待跟进客户', '待审核合同', '待审核回款', '即将到期合同' ],
      numList:[ '0', '0', '0', '0' ]
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    routerTo(index) {
      switch (index) {
        case 0:
          this.$router.push({
            name: 'customer-manage',
            params: {
              status: '待跟进',
            }
          });break;
        case 1:
          this.$router.push({
            name: 'contract-audit',
            params: {
              status: '待审核合同',
            }
          });break;
        case 2:
          this.$router.push({
            name: 'receipt-audit',
            params: {
              status: '待审核回款',
            }
          });break;
        case 3:
          this.$router.push({
            name: 'contract-manage',
            params: {
              status: '即将到期合同',
            }
          });break;
        default: break;
      }
    },
    getData() {
      this.axios.get(`/Crm/Static/MyAgent`).then(res => {
        this.numList = [
            res.followUpCount,
            res.noAuditContractCount,
            res.noAuditRecordCount,
            res.expiringContractCount
        ]
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .myToDo {
    box-sizing: border-box;
    border: 1px solid #dfe0eb;
    border-radius: 12px;
    padding: 18px 15px;
    margin-bottom: 20px;
    background: white;
    box-shadow: 0 2px 6px 0 rgba(218,218,253,65%), 0 2px 6px 0 rgba(206,206,238,54%);

    .title {
      font-weight: bold;
      font-size: 18px;
      margin-bottom: 10px;
    }

    ul {
      display: flex;
      justify-content: space-between;
      li {
        width: 21%;
        border: 1px solid #dfe0eb;
        border-radius: 12px;
        padding: 10px 5px;
        transition: all .2s;
        box-shadow: 0 2px 6px 0 rgba(218,218,253,65%), 0 2px 6px 0 rgba(206,206,238,54%);
        cursor: pointer;
        &:first-child {
          border-left: 3px solid #0dcaf0;
          &:hover {
            border: 1px solid #0dcaf0;
            b {
              color: #0dcaf0;
            }
          }
        }

        &:nth-child(2) {
          border-left: 3px solid #f41127;
          &:hover {
            border: 1px solid #f41127;
            b {
              color: #f41127;
            }
          }
        }

        &:nth-child(3) {
          border-left: 3px solid #17a00e;
          &:hover {
            border: 1px solid #17a00e;
            b {
              color: #17a00e;
            }
          }
        }

        &:nth-child(4) {
          border-left: 3px solid #ffc107;
          &:hover {
            border: 1px solid #ffc107;
            b {
              color: #ffc107;
            }
          }
        }

        .itemName {
          font-size: 16px;
          text-align: center;
          font-weight: bold;
        }

        .num {
          display: flex;
          justify-content: center;
          align-items: baseline;
          line-height: 30px;
          b {
            font-size: 28px;
            transition: color .2s;
          }
          span {
            color: #999999;
            margin-left: 5px;
          }
        }
      }
    }
  }
</style>
